import React, { useReducer } from 'react'
import AccessUsersReducer from './AccessUsersReducer';
import AccessUsersContext from './AccessUsersContext';
import { getAccessUsersService } from '../../services/accessUsers';

const AccessUsersState = ({ children }) => {

    const initialState = {
        accessUsers: [],
        isFetching: true,
        wasFetched: false,
        error: false,
        message: ''
    };

    const [state, dispatch] = useReducer(AccessUsersReducer, initialState);

    const getAccessUsers = async () => {
        try {
            if (state.wasFetched === false) {
                const accessUsers = await getAccessUsersService();
                if (accessUsers.ok) {
                    dispatch({
                        type: 'GET_ACCESS_USERS',
                        payload: accessUsers.data.response
                    });
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <AccessUsersContext.Provider
            value={{
                accessUsersState: state,
                getAccessUsers
            }}
        >
            {children}
        </AccessUsersContext.Provider>
    );
}

export default AccessUsersState